// Presentation only. War status, eligibility and HP remain server-authoritative.
export function clanLandingTab(previous, war) {
  return (!previous || previous === 'overview') && war?.status === 'active' ? 'wars' : (previous || 'overview');
}

export function validWarTarget(war, targetId, canAttack) {
  if (!canAttack || war?.status !== 'active') return '';
  const target = (war.opponent_roster || []).find(p => String(p.uid) === String(targetId));
  return target && (target.state || 'ready') === 'ready' ? String(target.uid) : '';
}

export function clanMembers(members, query = '') {
  const seen = new Set();
  const q = String(query).trim().toLocaleLowerCase('ru');
  return (Array.isArray(members) ? members : []).filter(m => {
    const id = String(m.id || '');
    if (!id || seen.has(id)) return false;
    seen.add(id);
    return !q || String(m.nickname || '').toLocaleLowerCase('ru').includes(q) || id.includes(q);
  });
}

export function warDefenseCards(war, uid, cards, verse) {
  const fighter = (war?.my_roster || []).find(p => String(p.uid) === String(uid));
  if (!fighter?.team) return [];
  const team = fighter.team;
  return Object.entries(team.slots || {}).sort(([a], [b]) => Number(a) - Number(b)).map(([slot, id]) => {
    // Never borrow same-id art from a different universe.
    const card = team.verce === verse ? (cards || []).find(c => String(c.id) === String(id)) : null;
    return { slot, id: String(id), card, hp: Math.max(0, Number(team.hp?.[id] || 0)) };
  });
}
